import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  CardOrden,
  ContainerP5,
  RefreshBox,
} from "./localStyle";
import { showToaster } from "global/context/action/toaster/toaster";
import { base64toBlob } from "global/utils/base64toBlob";
import PdfIcon from "_+_Portal/assets/images/generico/PdfIcon";
import camelize from "global/utils/camelize";
import {
  setAltaOrdenDigitalEstudio,
  setFlgVolverOrdenDigitalEstudio,
  setMedicoSolicitante,
  wsGetGrupoByIdOrden,
  wsGetOrdenDigitalEstudio,
  wsGetPDFOrdenEstudio,
} from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { PortalContext } from "_+_Portal/context/Provider";
import { useHistory } from "react-router";
import { FaSyncAlt } from "react-icons/fa";
import {
  setAltaTurnoOrdenDigital,
  wsGetLabOrdenDigital,
} from "_+_Portal/context/Actions/labOrdenDigital/labOrdenDigital";
import { wsGetPDFOrdenDigital } from "_+_Portal/context/Actions/pdfOrdenDigital/pdfOrdenDigital";
import fechaTurnoFormat from "global/utils/fechaTurnoFormat";
import { wsGetLaboCentros } from "_+_Portal/context/Actions/laboGrupo/laboGrupo";
import {
  setBuscarTurnoLabo,
  wsGetLaboTurnos,
} from "_+_Portal/context/Actions/turnos/laboTurnos";
import { editaTurnosDisponibles } from "_+_Portal/context/Actions/turnos/turnosDisponibles";
import { Capacitor } from "@capacitor/core";
import { detectarIOS } from "global/utils/detectarIOS";
import { Device } from "@capacitor/device";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { FileOpener } from "@capacitor-community/file-opener";
import { DistanciaCentro } from "../PagesFun";

const OrdenesDigitales = () => {
  // -------------------------  useContex  ----------------------------
  const { pasoDispatch } = useContext(AutocheckContext);
  const {
    ordenDigitalDispatch,
    laboGrupoDispatch,
    laboTurnosDispatch,
    labOrdenDigitalDispatch,
    turnosDisponiblesState,
    turnosDisponiblesDispatch,
  } = useContext(PortalContext);
  const { authState, toasterDispatch } = useContext(GlobalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  const history = useHistory();
  let getOrdenes = sessionStorage.getItem("getOrdenes");
  const currentDate = new Date().toLocaleString().replace(/[,:\s\/]/g, "-");
  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [ordenesList, setOrdenesList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingPDF, setLoadingPDF] = useState(false);
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const handleClickButton = (item) => {
    setLoadingPDF(true);
    if (item?.idLabProtAgenda) {
      wsGetPDFOrdenDigital(item.id, (isCorrect, data) => {
        if (isCorrect) {
          mostrarImagen(data, item);
        } else {
          showToaster(
            {
              texto: "Error al generar la orden.",
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
        }

        setLoadingPDF(false);
      })(labOrdenDigitalDispatch);
    } else {
      wsGetPDFOrdenEstudio(item.id, (isCorrect, data) => {
        if (isCorrect) {
          mostrarImagen(data, item);
        } else {
          showToaster(
            {
              texto: "Error al generar la orden.",
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
        }

        setLoadingPDF(false);
      })(ordenDigitalDispatch);
    }
  };

  const mostrarImagen = (data, item) => {
    // Normaliza la respuesta: puede venir como base64 (string) o como Blob o { blob }
    const getBlobAndBase64 = async (input) => {
      if (input && input.blob instanceof Blob) {
        const blob = input.blob;
        const base64 = await blobToBase64(blob);
        return { blob, base64 };
      }
      if (input instanceof Blob) {
        const blob = input;
        const base64 = await blobToBase64(blob);
        return { blob, base64 };
      }
      if (typeof input === "string") {
        const blob = base64toBlob(input, "application/pdf");
        return { blob, base64: input };
      }
      return { blob: null, base64: null };
    };

    const blobToBase64 = (blob) =>
      new Promise((resolve, reject) => {
        try {
          const reader = new FileReader();
          reader.onloadend = () => {
            const result = reader.result || "";
            const str = typeof result === "string" ? result : "";
            const commaIdx = str.indexOf(",");
            resolve(commaIdx >= 0 ? str.substring(commaIdx + 1) : str);
          };
          reader.onerror = (e) => reject(e);
          reader.readAsDataURL(blob);
        } catch (e) {
          reject(e);
        }
      });

    const run = async () => {
      const { blob, base64 } = await getBlobAndBase64(data);
      const isIOS = detectarIOS();
      if (Capacitor.isNativePlatform()) {
        // Código específico para plataformas nativas
        if (isIOS) {
          Device.getInfo().then((info) => {
            if (info.platform === "web") {
              const blobUrl = URL.createObjectURL(blob);
              const descarga = document.createElement(`a`);
              descarga.href = blobUrl;
              descarga.target = "_blank";
              descarga.download = `Informe-${item.idturnoorigen}.pdf`;
              document.body.appendChild(descarga);
              descarga.click();
              document.body.removeChild(descarga);
              setTimeout(() => URL.revokeObjectURL(blobUrl), 0);
            } else {
              downloadiOSFileNative(base64);
            }
          });
        } else {
          Device.getInfo().then((info) => {
            if (info.platform === "web") {
              const blobUrl = URL.createObjectURL(blob);
              const descarga = document.createElement("a");
              descarga.href = blobUrl;
              descarga.target = "_blank";
              descarga.download = `Informe-${item.idturnoorigen}.pdf`;
              document.body.appendChild(descarga);
              descarga.click();
              setTimeout(() => URL.revokeObjectURL(blobUrl), 0);
            } else {
              downloadPdfAndroidNative(base64);
            }
          });
        }
      } else {
        const nuevaVentana = window.open("", "_blank");
        if (nuevaVentana) {
          const blobUrl = URL.createObjectURL(blob);
          nuevaVentana.location.href = blobUrl;
          setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
        } else {
          showToaster(
            {
              texto: "El navegador bloqueó la apertura de la ventana.",
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
        }
      }
    };

    run();
  };

  const downloadiOSFileNative = (base64Data) => {
    const b64Data = base64Data;
    const fileName = `Informe-${currentDate}.pdf`;
    Filesystem.writeFile({
      path: fileName,
      data: b64Data,
      directory: Directory.Documents,
    }).then((c) => {
      const rutaGuardado = c.uri;
      try {
        const fileOpenerOptions = {
          filePath: rutaGuardado,
          contentType: "application/pdf",
          openWithDefault: true,
        };
        FileOpener.open(fileOpenerOptions);
      } catch (e) {
        console.log("Error opening file", e);
      }
    });
  };

  //necesario para el sdk actual
  const downloadPdfAndroidNative = (base64Data) => {
    const b64Data = base64Data;
    const fileName = `Informe-${currentDate}.pdf`;
    Filesystem.writeFile({
      path: `Download/${fileName}`,
      data: b64Data,
      directory: Directory.ExternalStorage,
    }).then((c) => {
      const rutaGuardado = c.uri;
      try {
        const fileOpenerOptions = {
          filePath: rutaGuardado,
          contentType: "application/pdf",
          openWithDefault: true,
        };
        FileOpener.open(fileOpenerOptions);
      } catch (e) {
        console.log("Error opening file", e);
      }
    });
  };

  const verAgendasDisponibles = (item) => {
    setLoadingPDF(true);
    if (!item?.requiereTurno) {
      setFlgVolverOrdenDigitalEstudio(true)(ordenDigitalDispatch);
    }
    setAltaOrdenDigitalEstudio(item.id)(ordenDigitalDispatch);
    setMedicoSolicitante(item.idMedSolicitante)(ordenDigitalDispatch);
    wsGetGrupoByIdOrden(item.id, (isCorrect, data) =>
      nextStep(isCorrect, data, item),
    )(ordenDigitalDispatch);
  };

  const asociarTurnoLabo = (data) => {
    // setPaso("EstudiosLabo")(pasoDispatch);
    setLoadingPDF(true);
    const fecha = fechaTurnoFormat();
    const idGrupoTurnoLaboGeneral = 5;
    setFlgVolverOrdenDigitalEstudio(true)(labOrdenDigitalDispatch);
    setAltaTurnoOrdenDigital(data?.idprotocolo)(labOrdenDigitalDispatch);
    setBuscarTurnoLabo(true)(laboTurnosDispatch);
    wsGetLaboCentros((isCorrect, dataCentros) => {
      if (isCorrect) {
        wsGetLaboTurnos(
          fecha,
          -1,
          -1,
          idGrupoTurnoLaboGeneral,
          -1,
          (isCorrect, data) => nextStepTurnoLabo(isCorrect, data, dataCentros),
        )(laboTurnosDispatch);
      } else {
        showToaster(
          {
            texto: "Error al obtener centros de laboratorio.",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      }
    })(laboGrupoDispatch);
  };

  const volver = () => {
    setPaso("Home")(pasoDispatch);
  };

  const refreshOrdenes = () => {
    setLoading(true);
    wsGetOrdenDigitalEstudio(
      authState?.auth?.data?.paciente?.codigo,
      nextStepOrdenes,
    )(ordenDigitalDispatch);
  };

  const nextStep = (isCorrect, data, item) => {
    if (isCorrect) {
      if (item?.requiereTurno) {
        setPaso("NumeroAfiliado")(pasoDispatch);
      } else {
        history.push("/estudios");
      }
    } else {
      showToaster(
        {
          texto: "Error al obtener grupos de estudio.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
    setLoadingPDF(false);
  };

  const nextStepTurnoLabo = (isCorrect, data, dataCentros) => {
    if (isCorrect) {
      let centros = [
        ...(turnosDisponiblesState?.turnosDisponibles?.turnosData?.filtrosData
          ?.centrosLabo ?? []),
        ...(dataCentros ?? []),
      ];

      // let turnoByCentro = data.data.filter((turno) => DistanciaCentro(turno));
      if (!data?.data || data.data.length === 0) {
        showToaster(
          {
            texto: "No hay turnos disponibles para el centro seleccionado.",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      } else {
        let descEstudio = "TURNO DE LABORATORIO GENERAL";
        editaTurnosDisponibles({
          ...(turnosDisponiblesState?.turnosDisponibles?.turnosData ?? {}),
          turnos: data?.data ?? [],
          grupoMedico: 5,
          particular: false,
          idEstudio: 5,
          descEstudio: descEstudio,
          descEspecialidad: null,
          fechaBusqueda: data?.fechaBusqueda,
          dtoBusqueda: { idGrupo: 5 },
          volverOrigen: "LABORATORIOQR",
          proceso: "labo",
          filtrosData: {
            ...(turnosDisponiblesState?.turnosDisponibles?.turnosData?.filtrosData ?? {}),
            centrosLabo: centros,
          },
        })(turnosDisponiblesDispatch);
        history.push("/turnosDisponibles");
        sessionStorage.removeItem("getOrdenes");
        sessionStorage.removeItem("ordenesList");
      }
    } else {
      showToaster(
        {
          texto: "Error al obtener grupos de laboratorio.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
    setLoadingPDF(false);
  };

  const nextStepOrdenes = (isCorrect, data) => {
    if (isCorrect) {
      wsGetLabOrdenDigital(-1, (isCorrect, dataLabo) =>
        nextStepLabo(isCorrect, data, dataLabo),
      )(labOrdenDigitalDispatch);
    } else {
      setLoading(false);
      showToaster(
        {
          texto: "Error al obtener ordenes digitales.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  const nextStepLabo = (isCorrect, data, dataLabo) => {
    if (isCorrect) {
      sessionStorage.setItem("getOrdenes", true);
      let ordenesConcat = [...(data ?? []), ...(dataLabo ?? [])];
      let ordenesSinAsociar = ordenesConcat.filter(
        (orden) =>
          orden.idTurno === null ||
          orden.idTurno === -1 ||
          orden.idLabProtAgenda === null ||
          orden.idLabProtAgenda === 0,
      );
      let ordenByFecha = ordenesSinAsociar.sort((a, b) => {
        const fechaA = a.fechaAlta || a.fechaalta;
        const fechaB = b.fechaAlta || b.fechaalta;
        return new Date(fechaB).getTime() - new Date(fechaA).getTime();
      });
      setOrdenesList(ordenByFecha);
      setLoading(false);
      sessionStorage.setItem("ordenesList", JSON.stringify(ordenesSinAsociar));
    } else {
      setLoading(false);
      showToaster(
        {
          texto: "Error al obtener ordenes de laboratorio.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  useEffect(() => {
    if (getOrdenes === null) {
      // wsGetOrdenesDigitalesById(authState.auth.data.paciente.codigo, nextStep);
      wsGetOrdenDigitalEstudio(
        authState?.auth?.data?.paciente?.codigo,
        nextStepOrdenes,
      )(ordenDigitalDispatch);
    } else {
      let ordenes = [];
      try {
        ordenes = JSON.parse(sessionStorage.getItem("ordenesList")) ?? [];
      } catch (e) {
        ordenes = [];
      }
      setLoading(false);
      setOrdenesList(ordenes);
    }
  }, []);
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading || loadingPDF}
        color="c-white"
        descripcion={"Cargando..."}
      />
      <RefreshBox>
        <button
          onClick={() => refreshOrdenes()}
          style={{
            backgroundColor: "#ffffff",
            border: "2px solid var(--color-latex30)",
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          className="spin"
        >
          <FaSyncAlt size={20} color="var(--color-latex30)" />
        </button>
      </RefreshBox>
      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"ÓRDENES PARA ESTUDIOS MÉDICOS"}
        subtitle={
          "Éstas son las órdenes digitales que tu médico indicó para que puedas sacar turno."
        }
        minSizeTxt={true}
      >
        {!loading && (
          <ContainerP5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BodyContainerP5>
              {ordenesList?.length > 0 &&
                ordenesList.map((element, index) => {
                  const esOrdenFutura = !!element?.enEspera;
                  const esOrdenVencida = !!element?.vencida;
                  const fechaValidezOrigen =
                    element?.fecha || element?.fechaalta;
                  const fechaValidezFormatted =
                    esOrdenFutura && fechaValidezOrigen
                      ? new Date(fechaValidezOrigen).toLocaleDateString(
                          "es-AR",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          },
                        )
                      : null;
                  return (
                    <CardOrden key={index}>
                      <p className="header rb18m c-white">
                        {element?.idprotocolo
                          ? "Laboratorio"
                          : element?.idGrupoEstudioDesc === null
                            ? "Estudio"
                            : camelize(element?.idGrupoEstudioDesc)}
                      </p>
                      <div className="bodyOrden">
                        <p>
                          Emitida el:{" "}
                          <span className="rb16m">
                            {new Date(
                              element?.fechaAlta || element?.fechaalta,
                            ).toLocaleDateString("es-AR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "2-digit",
                            })}
                          </span>
                        </p>
                        <p>
                          Médico:{" "}
                          <span className="rb16m">
                            {element?.idUsuarioAltaDesc}
                          </span>
                        </p>
                        <div
                          className="btnOrdenPdf rb14m"
                          onClick={() => handleClickButton(element)}
                        >
                          <PdfIcon /> Ver Orden
                        </div>
                        {esOrdenFutura ? (
                          <p
                            className="rb16l c-latex30"
                            style={{ textAlign: "center" }}
                          >
                            Esta orden tiene validez desde{" "}
                            {fechaValidezFormatted}
                          </p>
                        ) : esOrdenVencida ? (
                          <p
                            className="rb16l c-latex30"
                            style={{ textAlign: "center" }}
                          >
                            Orden vencida — fuera del plazo de validez de su
                            obra social
                          </p>
                        ) : (
                          <ButtonP5
                            onClick={
                              element?.idprotocolo
                                ? () => asociarTurnoLabo(element)
                                : () => verAgendasDisponibles(element)
                            }
                          >
                            {!element?.requiereTurno
                              ? "Solicitar turno"
                              : "Atenderme ya"}
                          </ButtonP5>
                        )}
                      </div>
                    </CardOrden>
                  );
                })}
            </BodyContainerP5>
          </ContainerP5>
        )}
      </LayoutPasos>
    </>
  );
};

export default OrdenesDigitales;
